import styled from "styled-components";

export const BetSelectionsContainer = styled.div<{
  isDark?: boolean;
}>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  flex-direction: row;
  height: 42px;
  width: fit-content;
  padding: 0 var(--fd-space-space-3);
  background-color: ${({ isDark }) =>
    isDark ? "var(--fd-colors-core-navy-d-4)" : "transparent"};
  border: 1px solid
    ${({ isDark }) =>
      isDark
        ? "var(--fd-colors-core-navy-d-4)"
        : "var(--fd-colors-border-default)"};
`;
